import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL,
	scrollBehavior (to, from, savedPosition) {
    if (to.hash){
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    }
    return { x: 1, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    // {
    //   path: '/partners',
    //   name: 'partners',
    //   component: () => import('./views/Partners.vue')
    // },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/Contact.vue')
    },
  ]
})
